import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import waterIcon from "../../../../../assets/design-revamp-company/company-detail-headers/water-icon.svg";
import { useTranslation } from "react-i18next";
import { getWater } from "../../../../../apis/Business/EnergyApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import waterGraphic1 from "../../../../../assets/design-revamp-company/company-detail-headers/water-graphic-icon-1.svg";
import waterGraphic2 from "../../../../../assets/design-revamp-company/company-detail-headers/water-graphic-icon-2.svg";

const WaterIcon = () => (
  <img src={waterIcon} alt="Water Icon" width={76} height={76} />
);

const WaterHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  totalObjWater,
  totalSavedWater,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <CategoryComponent
      show={show}
      className={`water-category ${className || ""}`}
      leftBoxProps={{
        icon: <WaterIcon />,
        title: t("WATER"),
        description: t("WATER_INFO"),
        scopes: [{ scope: "Scope 3", filled: true }],
        graphicIcons: [{ icon: waterGraphic1 }, { icon: waterGraphic2 }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_SAVED_WATER"),
            items: [
              {
                subtitle: "Liter",
                subitems: [
                  {
                    label: "Liter",
                    value: handleToFixedNum(
                      totalSavedWater,
                      totalSavedWater?.total_liter
                    ),
                  },
                ],
              },
              {
                subtitle: "DKK",
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalSavedWater,
                      totalSavedWater?.total_dkk_liter
                    ),
                  },
                ],
              },
              {
                subtitle: `tCO₂e (${t("OUTSIDE_SCOPES")})`,
                subitems: [
                  {
                    label: "tCO₂e",
                    value: handleToFixedNum(
                      totalSavedWater,
                      totalSavedWater?.total_used_carbon
                    ),
                  },
                ],
              },
            ],
          },
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjWater,
                      totalObjWater?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} ${handleToFixedNum(
                  totalObjWater,
                  totalObjWater?.total_emissions
                )} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalSavedWater,
                      totalSavedWater.total_drinking_water
                    ),
                    scopes: ["Scope 3"],
                  },
                  {
                    value: handleToFixedNum(
                      totalSavedWater,
                      totalSavedWater.total_equipment_water
                    ),
                    scopes: ["S:3, C:2"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjWater?.updated_at
          ? formatDate(totalObjWater?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default WaterHeader;
